import {useDrag} from "react-dnd";
import EntityLabel from "./entityLabel";
import {useApp} from "../app.context";
import {useNavTarget} from "./useNavTarget";
import {NavTarget} from "../utils/navTarget";

// `level` is forwarded to the rendered EntityLabel's image. Pass building.startLevel
// for buildings; omit for units / resources / tiles (defaults to 0).
function EntityDragLabel(props: {id: string, type: string, level?: number, navTarget?: NavTarget}) {
    const {setNotification} = useApp();

    const [{opacity}, drag] = useDrag({
        type: props.type,
        item: {
            id: props.id,
        },
        collect: (monitor) => {
            const isDragging = monitor.isDragging();
            const opacity = isDragging ? 0.5 : 1;
            return {
                opacity: opacity,
            };
        },
    });

    return (
        <div ref={drag} {...useNavTarget(props.navTarget)} style={{opacity: opacity}} onClick={() => {
            setNotification({
                title: props.id,
                message: props.id + '.description',
                edit: true
            })
        }}>
            <EntityLabel id={props.id} level={props.level}/>
        </div>
    )
}

export default EntityDragLabel;